import gql from "graphql-tag";
export const ORG_INFO_FRAGMENT = gql`
  fragment OrgInfo on Organization {
    id
    name
    slug
    isSlackInstalled
  }
`;
